import { Toast } from "vant"

const TokenKey = 'Authorization'

export function getToken() {
    return localStorage.getItem(TokenKey) ?? ''
}
export function setToken(token) {
    localStorage.setItem(TokenKey, token)
}
export function removeToken() {
    localStorage.removeItem(TokenKey)
    localStorage.removeItem('device-info')
    localStorage.removeItem('home-config');
    localStorage.removeItem('home-loan-info');
    localStorage.removeItem('user-id');
    window?.Android?.saveData('storageMap', '')
}


export function setStorage(name, value) {
    localStorage.setItem(name, value)
}
export function getStorage(name) {
    return localStorage.getItem(name) ?? ''
}
export function delStorage(name) {
    localStorage.removeItem(name)
}
export function clearStorage() {
    return localStorage.clear();
}


// 将日期转换为指定格式的字符串
export function formatDateTime(dateStr) {
    if (!dateStr) {
        return ''
    }
    const date = new Date(dateStr)
    const year = date.getFullYear(); // 年份
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份（注意要加上1）
    const day = date.getDate().toString().padStart(2, '0'); // 天数
    const hours = date.getHours().toString().padStart(2, '0'); // 小时
    const minutes = date.getMinutes().toString().padStart(2, '0'); // 分钟

    return `${year}-${month}-${day} ${hours}:${minutes}`;
}


// 复制字符串
export function copyStr(str) {
    const oInput = document.createElement('input');
    oInput.value = str;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象
    document.execCommand('Copy'); // 执行浏览器复制命令
    oInput.className = 'oInput';
    oInput.style.display = 'none';
    showToast('Copy success');
}

/**
 * px转rem 37.5
 * 用于 style 行内样式使用
 */
export function px2rem(px) {
    if (px) {
        if (/%/ig.test(px.toString())) { // 有百分号%，特殊处理，表述pc是一个有百分号的数，比如：90%
            return px
        } else {
            return (parseFloat(px.toString()) / 37.5) + 'rem'
        }
    } else {
        return 0
    }
}


/**
 * 针对app回调方法
 * funName: 方法名称
 */
export function callAppFun(funName, params) {
    console.log("🚀 ~ callAppFun ~ funName:" + funName)
    if (window?.Android) {
        return new Promise((resolve, reject) => {
            if (params) window?.Android[funName](params);
            else window?.Android[funName]();
            window[funName + 'Callback'] = (res) => {
                console.log("🚀 ~ returnnewPromise ~ res:" + res)
                resolve(res ?? 0)
                delete window[funName + 'Callback']
            }
        })
    } else {
        return Promise.resolve()
    }
}



/**
 * 调用app的提示框
 */
export function showToast(message) {
    if (window?.Android) {
        window?.Android?.showToast(message);
    } else {
        Toast(message)
    }
}

// 金额数字格式化
export function numberToCurrencyNo(value) {
    if (!value) return 0
    if (String(value).indexOf(',') != -1) return value
    // 获取整数部分
    value = Number(value)
    const intPart = Math.trunc(value)
    // 整数部分处理，增加,
    const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    // 预定义小数部分
    let floatPart = ''
    // 将数值截取为小数部分和整数部分
    const valueArray = value.toString().split('.')
    if (valueArray.length === 2) { // 有小数部分
        floatPart = valueArray[1].toString() // 取得小数部分
        return intPartFormat + '.' + floatPart
    }
    return intPartFormat + floatPart
}

// 千分位字符串转化为数据
export function remoney(s) {
    let str = ''
    if (s) {
        str = String(s).replace(/,/g, "")
    }
    if (s && (s + "").indexOf('.') > -1 && Number(str)) {
        return String(s).replace(/[^\d\.-]/g, "");
    } else if (s && Number(str)) {
        return str;
    } else {
        return s
    }
}

export function isAndroidVersionAtLeast15() {
    var userAgent = navigator.userAgent.toLowerCase();
    var androidVersionMatch = /android\s([0-9\.]*)/.exec(userAgent);
    if (androidVersionMatch && androidVersionMatch[1]) {
        var version = parseFloat(androidVersionMatch[1]);
        return version >= 15;
    }

    return false;
}